window.Popper = require('popper.js').default;
require('bootstrap');
// require('jquery-match-height');

require('@fortawesome/fontawesome-free/js/fontawesome.js');
require('@fortawesome/fontawesome-free/js/solid.js');
require('@fortawesome/fontawesome-free/js/regular.js');
require('@fortawesome/fontawesome-free/js/brands.js');

require('owl.carousel');

require("../scss/app.scss");
require("./offcanvas");
// require("../scss/app.rtl.scss");


// $(function() {
//     $('.equal-height-cards .card').matchHeight();
// });


$(function () {
  $('[data-toggle="tooltip"]').tooltip();
    // $(window).scroll(function (event) {
    //     var scroll = $(window).scrollTop();
    //     if(scroll > 20) {
    //         $('.header').addClass('is-sticky');
    //     } else {
    //         $('.header').removeClass('is-sticky');
    //     }
    //     // Do something
    // });
});

